import { CallDetail } from '../models/CallDetail';
import { StackFrameMapper } from './StackFrameMapper';

export class CallDetailMapper {
  private readonly stackFrameMapper = new StackFrameMapper();

  mapGQLModel(data: any): CallDetail {
    const stackTrace = data.stackTrace?.edges?.map((s: any, index: number) => this.stackFrameMapper.mapGQLModel(s.node, index)) || null;

    let args: object | null = null;
    try {
      args = JSON.parse(data.arguments);
    } catch {
      // Do nothing
    }

    return new CallDetail(args, stackTrace);
  }
}
